import { CloudDownloadOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import BluetoothActivate from './BluetoothTable/BluetoothActivate';
import BluetoothDeactivate from './BluetoothTable/BluetoothDeactivate';
import { useState } from 'react';

const Bluetooth = () => {
  const [activeTab, setActiveTab] = useState('1');
  const items = [
    {
      label: <span>Active</span>,
      key: '1',
      children: <BluetoothActivate activeTab={activeTab} />,
      icon: <SafetyCertificateOutlined rev={undefined} />,
    },
    {
      label: <span>Inactive</span>,
      key: '2',
      children: <BluetoothDeactivate activeTab={activeTab} />,
      icon: <CloudDownloadOutlined rev={undefined} />,
    },
  ];
  return (
    <div className="mainPage">
      <Tabs
        type="card"
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        style={{ height: '100%' }}
        items={items.map((tab) => {
          return {
            label: tab.label,
            key: tab.key,
            children: tab.children,
            icon: tab.icon,
          };
        })}
      />
    </div>
  );
};

export default Bluetooth;
